import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import { Grid, SvgIcon } from '@gik/ui';

export default function BenefitsListGrid(): React.ReactElement {
  const bem = bemBlock('benefits-list-grid');
  const { t } = useTranslation();
  return (
    <Grid className={bem()}>
      <div className={bem('item')}>
        <SvgIcon name="HeartOutline" className={bem('icon', null, 'tw-text-danger-600')} size="2xl" /> <br />
        <span className={bem('item-title tw-text-danger-600')}>{t(translationKeys.emotionalTitle)}</span>
        <p>{t(translationKeys.emotionalDescription)}</p>
      </div>
      <div className={bem('item')}>
        <SvgIcon name="NewspaperOutline" className={bem('icon', null, 'tw-text-neutral-600')} size="2xl" />
        <br />
        <span className={bem('item-title tw-text-neutral-900')}>{t(translationKeys.informationalTitle)}</span>
        <p>{t(translationKeys.informationalDescription)}</p>
      </div>
      <div className={bem('item')}>
        <SvgIcon name="HandOutline" className={bem('icon', null, 'tw-text-info-600')} size="2xl" />
        <br />
        <span className={bem('item-title tw-text-info-600')}>{t(translationKeys.tangibleTitle)}</span>
        <p>{t(translationKeys.tangibleDescription)}</p>
      </div>
      <div className={bem('item')}>
        <SvgIcon name="UserGroupOutline" className={bem('icon', null, 'tw-text-secondary-600')} size="2xl" />
        <br />
        <span className={bem('item-title tw-text-secondary-600')}>{t(translationKeys.belongingTitle)}</span>
        <p>{t(translationKeys.belongingDescription)}</p>
      </div>
    </Grid>
  );
}
